import React from 'react';
import Radium from 'radium';
import {Input,Button,Modal,Collapse} from 'reactstrap';
import axios from 'axios';
import qs from 'qs';
import history from '../history';
import {reactLocalStorage} from 'reactjs-localstorage';
import NavigationBar from '../components/navigationbar'
import LoadingScreen from '../components/LoadingScreen';
import * as GLOBAL from './global.js'

import defaultProfile from '../assets/images/profileImage.png'

import {FaUser,FaEye} from "react-icons/fa"

export default class ClientBackground extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            participantList:[],
            searchedList:[],

            editBackgroundModal:false,
            editMemberBackground:null,
            editingMember:null,
            focusingElement:null,

            findField:"",
            searching:false,


            viewBackrgound:false,
            collapseStates: {},
            focusStates:{},
            currentClass:null,
           
        }
        this.dayList=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"]
        this.classType=null
        this.classID=null
        this.toggle = this.toggle.bind(this);
        
        this.currentDivCollapseRefs = {};
        this.searchDivCollapseRefs = {};
           
    }

    componentDidMount=()=>{
        axios.defaults.headers.common.Authorization = `Token ${reactLocalStorage.get("token")}`
        this.launchFunc()
    }

    launchFunc=()=>{
        //verify that user is logged in
        if(!reactLocalStorage.get("token")){
            history.push("./")
            return
        }

        //parse
        let pars=window.location.search.substr(1)
        let inputSplit=pars.split("&")
        for(let input of inputSplit){
            let param=input.split("=")[0]
            let value=input.split("=")[1]
            if(param=="type"){
                this.classType=value
            }else if(param=="class"){
                this.classID=value
            }
        }

        this.loadClassBackgroundInfo()
    }

    handleEditClick = (e, item) => {
        // Stop the click event from bubbling up to the collapse button
        e.stopPropagation();
        
        this.setState({
            editBackgroundModal: true,
            editMemberBackground:(item.user?item.user.background:item.nonMember.background),
            editingMember: (item.user ? item.user.username : item.nonMember.phone),
            focusingElement:(item.id)
        });
        }

    handleModalClose = () => {
        // Focus back on the button when the modal closes
        if (this.currentDivCollapseRefs[this.state.focusingElement]) {
            this.currentDivCollapseRefs[this.state.focusingElement].focus();
            this.currentDivCollapseRefs[this.state.focusingElement].scrollIntoView({ behavior: 'smooth', block: 'center' });

        }
        
    }

    closeCollapse = (itemId) => {
        this.setState((prevState) => ({
          focusStates: {
            ...prevState.focusStates,
            [itemId]: false,
          },
          collapseStates: {
            ...prevState.collapseStates,
            [itemId]: false, // Ensure collapseStates also updates to false on blur
          },
        }));
      };

    toggle = (itemId) => {
        this.setState((prevState) => ({
            collapseStates: {
            ...prevState.collapseStates,
            [itemId]: !prevState.collapseStates[itemId],
            },
            focusStates: {
                ...prevState.focusStates,
                [itemId]: !prevState.collapseStates[itemId],
            },
        }));
    };

    setDivRef = (itemId, element) => {
        
        this.currentDivCollapseRefs[itemId] = element;
       
    };
      
    saveRemark=(ticketNumber,remark)=>{
        this.setState({loading:true})
        const payLoad = {
            ticketNumber:ticketNumber,
            remark:remark,
        }
        axios
            .post(`sales/saveofflineeventbookingremark`, qs.stringify(payLoad))
            .then(async response => {
                this.setState({loading:false})
            })
            .catch(error => {
                if(error.response){
                    if(error.response.status==460){
                        alert("Your account is logged in another device, please relog")
                        this.setState({loading:false})
                        return
                    }
                }
                alert("Save "+this.eventName+" booking remark error\n" + error)
                this.setState({loading: false,})
            });
    }
  
    searchMember = () => {
        this.setState({ loading: true, searching: true });
        
        // Get and clean up the search term from the input field
        let searchTerm = this.state.findField
            .replace(/\s{2,}/g, ' ') // Replace multiple spaces with a single space
            .trim()                  // Trim leading and trailing whitespace
            .toLowerCase();          // Convert to lowercase for case-insensitive search
    
        let filteredMembers = [];
        for (let person of this.state.participantList) {            
            // Check if any field matches the search term
            if (
                (person.user? person.user.name?.toLowerCase().includes(searchTerm):person.nonMember.name?.toLowerCase().includes(searchTerm) ) ||
                (person.user? person.user.company?.toLowerCase().includes(searchTerm): person.nonMember.company?.toLowerCase().includes(searchTerm)) ||
                (person.user? person.user.email===searchTerm: person.nonMember.email === searchTerm) ||
                (person.user? person.user.username === searchTerm: person.nonMember.phone === searchTerm) 
               
              
            ) {
                filteredMembers.push(person); // Add member to filtered list
            }
        }
        this.setState({ searchedList: filteredMembers, loading: false });
    };

    generateAttendanceUI=(item)=>{
        let sDate=new Date(this.state.currentClass.eventDateObj)
        let eDate=new Date(this.state.currentClass.endDateObj)
        let attendanceBadge=[]
        while(sDate<=eDate){
            if(item.attendance!=null&&item.attendance[sDate.getDate()]!=undefined&&item.attendance[sDate.getDate()]==true){
                attendanceBadge.push(
                    <div style={{width:20,height:20,textAlign:"center",display:"flex",flexDirection:"row",alignItems:"center",
                        justifyContent:"center",borderRadius:"50%",backgroundColor:"green",
                    }}>
                        <div style={{fontSize:13,color:"white"}}>{sDate.getDate()}</div>
                    </div>
                )
            }else{
                attendanceBadge.push(
                    <div style={{width:20,height:20,textAlign:"center",display:"flex",flexDirection:"row",alignItems:"center",
                        justifyContent:"center",borderRadius:"50%",backgroundColor:"red",
                    }}>
                        <div style={{fontSize:13,color:"white"}}>{sDate.getDate()}</div>
                    </div>
                )
            }

            sDate.setDate(sDate.getDate() + 1)
        }

        return(
            <div style={{display:"flex",flexDirection:"row",gap:3,justifyContent:"center"}}>
                {attendanceBadge}
            </div>
        )
    }
    
    saveClientBackground=()=>{
        this.setState({loading:true})
        const payload = {
            memberID:this.state.editingMember,
            editMemberBackground:this.state.editMemberBackground,
        }
        axios
            .post(`sales/saveclientbackground`, qs.stringify(payload),{timeout:15000})
            .then(async response => {
                let updatedParticipantList = this.state.participantList.map(participant => {
                    if (participant.user) {
                        // Handle member case
                        if (participant.user.username === this.state.editingMember) {
                            return {
                                ...participant,
                                user: {
                                    ...participant.user,
                                    background: this.state.editMemberBackground
                                }
                            };
                        }
                    } else {
                        // Handle non-member case
                        if (participant.nonMember.phone === this.state.editingMember) {
                            return {
                                ...participant,
                                nonMember:{
                                        ...participant.nonMember,
                                        background: this.state.editMemberBackground
                                    }
                            };
                        }
                    }
                    return participant;
                });
                
                let updatedSearchedList = this.state.searching 
                    ? this.state.searchedList.map(participant => {
                        if (participant.user) {
                            // Handle member case
                            if (participant.user.username === this.state.editingMember) {
                                return {
                                    ...participant,
                                    user: {
                                        ...participant.user,
                                        background: this.state.editMemberBackground
                                    }
                                };
                            }
                        } else {
                            // Handle non-member case
                            if (participant.nonMember.phone === this.state.editingMember) {
                                return {
                                    ...participant,
                                    nonMember:{
                                        ...participant.nonMember,
                                        background: this.state.editMemberBackground
                                    }
                                };
                            }
                        }
                        return participant;
                    })
                    : [];

                this.setState({
                    editBackgroundModal: false,
                    participantList: updatedParticipantList,
                    searchedList: this.state.searching ? updatedSearchedList : [],
                    loading: false
                })
              
                alert("User background info saved")

                this.loadClassBackgroundInfo()
            })
            .catch(error =>{
                if(error.response){

                }
                alert("Edit member background info error\n"+error)
                this.setState({loading:false})
            })
    }

    loadClassBackgroundInfo=()=>{
        this.setState({loading:true})

        const payLoad = {
            classType:this.classType,
            classID:this.classID,
        }

        axios
            .post(`sales/loadclassbackgroundinfo`, qs.stringify(payLoad),{timeout:30000})
            .then(async response => {
                for(let booking of response.data.nameList){
                    // Parse signupDate
                    if(booking.signupDate){
                        let rawDateSplit = booking.signupDate.split("T");
                        let dateSplit = rawDateSplit[0].split("-");
                        let timeSplit = rawDateSplit[1].split(":");
                        booking.signupDate = dateSplit[2] + "." + dateSplit[1] + "." + dateSplit[0] + " " + timeSplit[0] + ":" + timeSplit[1];
                    }
                    if (booking.nonMember && (booking.nonMember.company == "null" || booking.nonMember.company == "")) {
                        booking.nonMember.company = null;
                    }
                    if(booking.nonMember && (booking.nonMember.industry=="null"||booking.nonMember.industry=="")){
                        booking.nonMember.industry=null
                    }                        
                    if (booking.user && (booking.user.company == "null" || booking.user.company == "")) {
                        booking.user.company = null;
                    }
                    if (booking.user && (booking.user.industry == "null" || booking.user.industry == "")) {
                        booking.user.industry = null;
                    }  
                }

                //class name
                if(this.classType=="course"){
                    response.data.currentClass.title=response.data.currentClass.courseTitle
                    response.data.currentClass.venue=response.data.currentClass.venueCity
                    response.data.currentClass.seatNumber=response.data.currentClass.seatForNew+response.data.currentClass.seatForRevision
                }
                //offline event day span
                let attendance={}
                let startDate=null
                if(this.classType=="offlineevent"){
                    startDate=new Date(response.data.currentClass.startDate)
                }else if(this.classType=="course"){
                    startDate=new Date(response.data.currentClass.eventDate)
                }
                response.data.currentClass.eventDateObj=new Date(startDate)
                let endDate=new Date(response.data.currentClass.endDate)
                response.data.currentClass.endDateObj=new Date(endDate)
                let currentDate=startDate
                while(currentDate<=endDate){
                    attendance[""+currentDate.getDate()]=0
                    currentDate.setDate(currentDate.getDate() + 1)
                }
                response.data.currentClass.attendance=attendance
                //offline event date
                //startDate
                let rawDateSplit=null
                if(this.classType=="offlineevent"){
                    rawDateSplit=response.data.currentClass.startDate.split("T")
                }else if(this.classType=="course"){
                    rawDateSplit=response.data.currentClass.eventDate.split("T")
                }
                let dateSplit=rawDateSplit[0].split("-")
                let timeSplit=null
                if(this.classType=="offlineevent"){
                    timeSplit=rawDateSplit[1].split(":")
                }else if(this.classType=="course"){
                    timeSplit=response.data.currentClass.startTime.split(":")
                }
                let theDay=null
                if(this.classType=="offlineevent"){
                    theDay=new Date(response.data.currentClass.startDate).getDay()
                }else if(this.classType=="course"){
                    theDay=new Date(response.data.currentClass.eventDate).getDay()
                }
                theDay=this.dayList[theDay]
                response.data.currentClass.startDate=dateSplit[2]+"/"+dateSplit[1]+"/"+dateSplit[0]+" ("+theDay+")  "+timeSplit[0]+":"+timeSplit[1]
                //endDate
                rawDateSplit=response.data.currentClass.endDate.split("T")
                dateSplit=rawDateSplit[0].split("-")
                if(this.classType=="offlineevent"){
                    timeSplit=rawDateSplit[1].split(":")
                }else if(this.classType=="course"){
                    timeSplit=response.data.currentClass.endTime.split(":")
                }
                theDay=new Date(response.data.currentClass.endDate).getDay()
                theDay=this.dayList[theDay]
                response.data.currentClass.endDate=dateSplit[2]+"/"+dateSplit[1]+"/"+dateSplit[0]+" ("+theDay+") "+timeSplit[0]+":"+timeSplit[1]
                //offline event daily attendance count
                for(let booking of response.data.nameList){
                    if(booking.attendance!=null){
                        for(const[key,value] of Object.entries(booking.attendance)){
                            for(const[rkey,rvalue] of Object.entries(response.data.currentClass.attendance)){
                                if(rkey==key&&value==true){
                                    response.data.currentClass.attendance[rkey]=rvalue+1
                                }
                            }
                        }
                    }
                }
                 
                this.setState({
                    loading:false,
                    participantList:response.data.nameList,
                    currentClass:response.data.currentClass,
                })                  
            }).catch(error => {
                if(error.response!=null){
                    if(error.response.status === 409){
                        alert("Not verified to view")
                        history.goBack()
                        this.setState({loading:false})
                        return
                    }
                }

                alert("Load class background info error\n" + error)
                history.goBack()
                this.setState({loading: false,})
            })
    }

    generateParticipantList=(item)=>{
        return(
            <div style={{display:"flex",flexDirection:"column",width:window.innerWidth<=600?"100%":"400px", border:"1px solid lightgrey",borderRadius:10,padding:10,gap:5}}>
                <div style={{display:"flex", flexDirection:"row", gap:10,width:"100%"}}>
                    <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"center", justifyContent:"center"}}>
                        <img style={{width: "100%",maxWidth:90,objectFit:"cover",borderRadius: "50%",backgroundColor: "grey"}} src={item.user!=null?(item.user.profileImage||defaultProfile):(defaultProfile)} alt=""/>
                        {
                        item.user?
                            <div style={{fontSize:10,color:"white",backgroundColor:"steelblue",borderRadius:5,padding:"2px 15px"}}>Member</div>
                            :
                            <div style={{fontSize:10,color:"white",backgroundColor:"grey",borderRadius:5,padding:"2px 15px"}}>Non Member</div>
                        }
                        <div style={{width:"100%",textAlign:"center"}}>
                            <div><b>Attendance:</b></div>
                            {this.generateAttendanceUI(item)}
                        </div>
                    </div>

                    <div style={{width:"100%",wordWrap:"break-word",wordBreak:"break-word", overflowWrap:"break-word",lineHeight:1.25,gap:5,display:"flex",flexDirection:"column"}}>
                        <div style={{display:"flex",flexDirection:"row",gap:10,alignItems:"center",justifyContent:"space-between"}}>
                            <div style={{fontSize:18,fontWeight:"bold"}}>{item.user?item.user.name:item.nonMember.name}</div>
                            <div style={{display:"flex",flexDirection:"row",gap:7,alignItems:"center"}}>
                                {
                                item.revision==true?
                                    <div style={{fontSize:12,padding:5,backgroundColor:"#539440",color:"white",borderRadius:5}}>Rev</div>
                                    :
                                    null
                                }
                                {
                                item.user!=null?
                                    <Button color="light" style={{padding:"2px 5px",border:"1px solid lightgrey"}} onClick={()=>{
                                        window.open("/saleslog?username="+item.user.username,"_blank")
                                    }}>
                                        <FaEye style={{}} />
                                    </Button>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"space-between",fontSize:14,color:"grey"}}>
                            <div style={{}}>{item.user?item.user.username:item.nonMember.phone}</div>
                            <div style={{}}>{item.user?item.user.email:item.nonMember.email}</div>                                                                    
                        </div> 
                        <div style={{width:"100%",display:"flex",flexDirection:"row",gap:5,marginTop:5}}>
                            <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center"}}>
                                <div style={{width:"50%"}}><b>Company:</b><br></br>{item.user?(item.user.company?item.user.company:"-"):(item.nonMember.company?item.nonMember.company:"-")}</div>
                                <div style={{width:"50%"}}><b>Industry:</b><br></br>{item.user?(item.user.industry?item.user.industry:"-"):(item.nonMember.industry?item.nonMember.industry:"-")}</div>                                                                  
                            </div> 
                        </div>
                        <div style={{}}><b>Referrer:</b>&nbsp;
                            {
                            item.user? 
                                item.user.referrer 
                                : 
                                item.nonMemberReferrer? item.nonMemberReferrer 
                                : 
                                item.nonMemberAgentCompany? item.nonMemberAgentCompany 
                                : 
                                "-"
                            }
                        </div>
                        <div style={{}}><b>PIC:</b>{item.user?item.user.personInCharge:"-"}</div>
                        <div>
                            <b>Agency:</b>&nbsp;
                            {
                            item.user!=null?
                                item.user.agency!=null?
                                    item.user.agency
                                    :
                                    "-"
                                :
                                item.nonMemberAgentCompany!=null?
                                    item.nonMemberAgentCompany
                                    :
                                    "-"
                            }
                        </div>
                        <div>
                            <b>SIC:</b>&nbsp;
                            {
                            item.user!=null?
                                item.user.staffInCharge!=null?
                                    item.user.staffInCharge
                                    :
                                    "-"
                                :
                                null
                            }
                        </div>
                        <div style={{}}><b>Sign Up Date:</b>&nbsp;{item.signupDate}</div>
                    </div>
                </div>
                
                <div tabindex={0} onFocus={() => this.setState({ focusStates: { ...this.state.focusStates, [item.id]: true } })} onBlur={() => this.closeCollapse(item.id)}  ref={(element) => this.setDivRef(item.id, element)} >
                    <Button color="secondary" onClick={(event)=> this.toggle(item.id)} size="lg"style={{width:"100%", lineHeight:2,paddingLeft:"5px",paddingRight:"5px", fontSize:"14px",gap:5,display:"flex"}}  >
                        <Collapse   isOpen={this.state.focusStates?.[item.id]||this.state.collapseStates[item.id] }style={{ width: "100%" }}>                                                               
                            <div style={{display:"flex", gap:5, flexDirection:"column"}}>
                                <div style={{width:"100%",flex:1,display:"flex",flexDirection:"row", justifyContent:"center", alignItems:"center",gap:5}}>
                                    <div style={{width:"25%",display:"flex",flexDirection:"column",textAlign:"end"}}>
                                        <b>Remark:</b>
                                    </div>
                                    <textarea type="text" style={{width:"75%",lineHeight:1,border:"1px solid lightgrey",borderRadius:5,padding:"5px 10px"}} value={item.remark!=null?item.remark:""} rows="2"
                                        onChange={(e)=>{
                                            e.stopPropagation()
                                            let cloneCSD=this.state.participantList
                                            for(let cs of cloneCSD){
                                                if(cs.id==item.id){
                                                    cs.remark=e.target.value
                                                }
                                            }
                                            this.setState({participantList:cloneCSD})
                                        }}
                                        onKeyDown={(e)=>{
                                            if (e.key === ' ' || e.key === 'Space') {
                                                // Only allow space and not more function of spacebar
                                                e.preventDefault();
                                                document.execCommand('insertText', false, ' ');
                                                return
                                            }
                                            if(e.keyCode==13){
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.saveRemark(item.ticketNumber,e.target.value);
                                            }
                                        }}
                                        onBlur={(e)=>{
                                            if(!GLOBAL.checkPermission("b*k]6EHR")){  //Save Offline Event Booking Remark
                                                return
                                            }
                                            this.saveRemark(item.ticketNumber,e.target.value)
                                        }}
                                        onClick={(e)=>{
                                            e.stopPropagation()
                                        }}
                                        readOnly={!GLOBAL.checkPermission("b*k]6EHR")}    //Save Offline Event Booking Remark
                                    />
                                </div>

                                <div style={{width:"100%",flex:1,display:"flex",flexDirection:"row",gap:5}}>
                                    <div style={{width:"25%",display:"flex",flexDirection:"column",paddingTop:"1px",gap:2}}>
                                        <div style={{alignSelf:"flex-end"}}><b>Background:</b></div>
                                        {
                                        GLOBAL.checkPermission("4~C$$mtS")?
                                            <Button color="primary" style={{alignSelf:"flex-end",padding:"1px 10px"}} onClick={(e) => this.handleEditClick(e, item)}  onBlur={(e) => {
                                                e.stopPropagation(); 
                                            }} >
                                                Edit
                                            </Button>
                                            :
                                            null
                                        }
                                    </div>
                                    <div style={{width:"75%",display:"flex",flexDirection:"column",border:"1px solid lightgrey",borderRadius:5,lineHeight:1, background:"white", color:"black",alignItems:"flex-start",padding:"5px 10px"}}>
                                        {
                                        item.user?
                                            item.user.background?
                                                item.user.background.split("\n").map((line)=>{return(<div>{line}</div>)})
                                                :
                                                null
                                            :
                                            item.nonMember.background?
                                                item.nonMember.background.split("\n").map((line)=>{return(<div>{line}</div>)})
                                                :
                                                null
                                        }
                                    </div>      
                                </div>
                            </div>
                        </Collapse>
                    </Button>                
                </div>
            </div>
        )
    }

    render(){
        return(
            <div>
                {
                this.state.loading?
                    <LoadingScreen />
                    :null
                }
                <Modal isOpen={this.state.editBackgroundModal} toggle={()=>this.setState({editBackgroundModal:false})} style={{}} returnFocusAfterClose={false} onClosed={()=>this.handleModalClose()}>
                    <div style={{padding:25,borderRadius:10}}>
                        <div style={{marginBottom:10,fontWeight:"bold",textAlign:"center",fontSize:20}}>Edit Background Info</div>
                        <textarea style={{padding:10,width:"100%",border:"1px solid lightgrey",borderRadius:5}} rows={7} value={this.state.editMemberBackground} onChange={(e)=>{
                            this.setState({editMemberBackground:e.target.value})
                        }} />
                        <div style={{display:"flex",flexDirection:"row",gap:10,marginTop:20}}>
                            <Button color="primary" style={{flex:1,}} onClick={()=>{
                                this.saveClientBackground()
                            }}>
                                Save
                            </Button>
                            <Button color="secondary" style={{flex:1,backgroundColor:"salmon",border:"none"}} onClick={()=>{
                                this.setState({editBackgroundModal:false})
                            }}>
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal>
              

                <NavigationBar currentPage="clientbackground"/>
                
                <div style={{width:"100%", justifyContent:"center", alignItems:"center",display:"flex",padding:"0px 2px 0px 2px",fontSize:"14px"}}>  {/*desktopView*/}
                    <div style={{gap:5,display:"flex",flexDirection:"column",width:"100%", justifyContent:"center",alignItems:"center",padding:10}}>
                        {
                        this.state.currentClass!=null?
                            <div style={{width:"100%",display:"flex",flexDirection:"column"}}>
                                <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",gap:5}}>
                                    <div style={{fontSize:22,fontWeight:"bold"}}>{this.state.currentClass.title}</div>
                                    <Button color="primary" style={{padding:"2px 8px",fontSize:13}} onClick={()=>{
                                        if(this.state.currentClass!=null){
                                            GLOBAL.copyTextToClipboard("https://enlliance.com/"+this.state.currentClass.link+"?intro="+reactLocalStorage.get("referCode")+"&class="+this.state.currentClass.id)
                                        }
                                    }}>
                                        Refer Link
                                    </Button>
                                </div>
                                <div style={{fontSize:12}}>
                                    {this.state.currentClass.startDate} ~ {this.state.currentClass.endDate}<br/>
                                    Venue: {this.state.currentClass.venue}
                                </div>
                                <div style={{fontSize:12,display:"flex",flexDirection:"row",gap:10}}>
                                    <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
                                        <FaUser style={{fontSize:10,marginRight:2}} />
                                        {this.state.currentClass.bookedSeat}/{this.state.currentClass.seatNumber}
                                    </div>
                                    <div style={{display:"flex",flexDirection:"row",alignItems:"center",gap:10}}>
                                        {
                                        Object.keys(this.state.currentClass.attendance).map((day)=>{
                                            return(
                                                <div style={{padding:"5px 10px",border:"1px solid lightgrey",borderRadius:5}}>
                                                    <b style={{color:"grey"}}>{day}th</b>&nbsp;:&nbsp;{this.state.currentClass.attendance[day]}/{this.state.participantList.length}
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        <div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",marginBottom:2, marginTop:2}}>
                            <Input type="text" name="username" placeholder="name / email / phone number / company name "
                                style={{marginRight:10}}
                                value={this.state.findField}
                                onChange={event => this.setState({findField: event.target.value})}
                                onKeyDown={(e)=>{
                                    if(e.keyCode==13){
                                        e.preventDefault()
                                        this.searchMember()
                                    }
                                }}
                                />
                            <Button color="danger" style={{paddingLeft:20,paddingRight:20,whiteSpace:"nowrap",marginRight:5}} onClick={()=>{this.setState({findField:"", searching:false})}}>Clear Query</Button>
                            <Button color="primary" style={{paddingLeft:20,paddingRight:20}} onClick={()=>{this.searchMember()}}>Search</Button>
                        </div>
                        <div style={{display:"flex", flexDirection:"row",flexShrink:0, flexFlow:"row",flexWrap:"wrap", gap:10,alignItems:"center", justifyContent:"center",width:"100%"}}>
                            {
                            !this.state.searching? //desktop full list view
                                this.state.participantList.map((item)=>{
                                    return(this.generateParticipantList(item))
                                })
                                : //desktop search view
                                this.state.searchedList.map((item)=>{
                                    return(this.generateParticipantList(item))
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

let styles={

}
